import styled from "styled-components";

export const Info = styled.div`
    width: 100%;
    height: 100%;
    z-index: 5;
    box-sizing: border-box;
    cursor: default;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 0;
        visibility: hidden;
    }
    //@media (max-height: 940px) {
    //    //top: 58px;
    //    //max-width: 360px;
    //    //width: 360px;
    //    //
    //    //max-height: 572px;
    //    //height: 572px;
    //    width: 100%;
    //    height: 100%;
    //    padding: 10px 30px;
    //    overflow-y: scroll;
    //    
    //    &::-webkit-scrollbar {
    //        width: 0;
    //        visibility: hidden;
    //    }
    //}
`

export const TopContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    user-select: none;
    & > div:nth-child(1) {
        color: #23AF91;
        font-size: 10px;
        width: 100%;
    }
    & > div:nth-child(2) {
        //margin-top: px;
        display: flex;
        width: 100%;
        height: 160px;
        color: white;
        font-size: 12px;
        letter-spacing: 0.6px;
        cursor: default;
        text-align: justify;
    }
`
export const InfoHeader = styled.div`
    display: flex;
    width: 100%;
    height: 260px;
`

export const InfoMainContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    user-select: none;
    & > div:first-child {
        color: #23AF91;
        font-size: 10px;
        width: 100%;
    }
`
export const FAQCell = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`
export const FAQHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 55px;
    color: white;
    font-size: 12px;
    letter-spacing: 0.6px;
    cursor: pointer;
    & > div {
        & > svg {
            stroke: #929AA5;
        }
    }
`
export const FAQMainContainer = styled.div<{ isOpen: boolean }>`
    letter-spacing: 0.55px;
    font-size: 11px;
    color: #929AA5;
    display: ${({isOpen}) => isOpen ? 'flex' : 'none'};
    cursor: default;
    text-align: justify;
`
export const Filler = styled.div`
    width: 100%;
    height: 120px;
`